import Swal from 'sweetalert2';
import axios from 'axios';

$('#language-form').asyncForm((err, data) => {
    window.location.reload();
});

const upload = image => {
    return axios.post(window.basepath + '/de_DE/image_upload?api', { image });
};

const remove = async image => {
    const { value } = await Swal.fire({
        title: "Bild löschen!",
        text: 'Soll das Bild wirklich gelöscht werden?\nGelöschte Dateien können NICHT wiederhergestellt werden.',
        icon: "",
        buttons: {
            delete: {
                text: "Unwiderruflich löschen",
                value: "delete",
                className: "swal-btn-deletemachine",
            },
            abbruch: {
                text: "Abbruch",
                value: "cancel",
            },
        },
        dangerMode: true,
    });
    if (value) {
        return await axios.get(window.basepath + `/de_DE/image_delete?api&image=${encodeURIComponent(image)}`);
    }
    throw Error();
};

$('.gallery-upload .panel').click(function () {
    const fileDialogue = $('<input type="file" multiple accept="application/pdf,image/*">').appendTo(document.body).get(0);
    fileDialogue.addEventListener('change', async e => {
        const files = [...e.target.files];
        const promises = [];
        for (let file of files) {
            const reader = new FileReader();
            reader.onload = e => {
                const  p = upload(e.target.result);
                promises.push(p);
            };
            reader.readAsDataURL(file);
        }
        try {
            promises.push(new Promise(res => setTimeout(res, 1000)))
            await Promise.all(promises);
            window.location.reload();
        } catch (err) {
            Swal.fire({ text: "Bild konnte nicht hochgeladen werden", icon: "error", showCancelButton: false });
        }
    });
    fileDialogue.click();
});

$('.btn-delete').click(async function () {
    const $img = $(this).closest('.gallery-image');
    const imgId = $img.data('image');
    console.log(imgId);
    try {
        await remove(imgId);
        window.location.reload();
    } catch (err) {
        Swal.fire({ text: "Bild konnte nicht gelöscht werden", icon: "error", showCancelButton: false });
    }
});

$('.gallery-modal').galleryModal();

$('.gallery-image .btn-edit-image').editImageModal();

$('#modal-picedit').on('shown.bs.modal', function () {
    cropper = new Cropper(image, {
        autoCropArea: 1,
        responsive: true,
        ready: function () {
            // Should set crop box data first here                    
            // cropper.setCropBoxData(cropBoxData).setCanvasData(canvasData);

            $('#btn-rotate-right').click(function () {
                cropper.rotate(90);
            });

            $('#btn-rotate-left').click(function () {
                cropper.rotate(-90);
            });
            $('#btn-zoom-plus').click(function () {
                cropper.zoom(0.1);
            });
            $('#btn-zoom-minus').click(function () {
                cropper.zoom(-0.1);
            });

            $('#btn-picedit-save').click(function () {
                const picture = cropper.getCroppedCanvas().toDataURL();
                const machineno = $('#global-machineno').val();
                const adressid = $('#global-adressid').val();
                const imgname = $('#btn-picedit-save').data('image');
                axios.post('?api&p=machine_picture-upload-post', { picture, adressid, machineno, filename: imgname})
                .then(() => cropper.disable())
                .catch(err => toastr.error(err))
                .finally(() => {
                    cropper.enable();
                    cropBoxData = null;
                    canvasData = null;
                    cropper.destroy();
                    $('#btn-saveall').click();
                    $('#modal-picedit').modal('hide');
                });
            });
        }
    });
}).on('hidden.bs.modal', function () {
    cropBoxData = null;
    canvasData = null;
    cropper.destroy();
});